<template>
  <footer>
    <div class="bg-primary">
      <ul>
        <li>
          <a href="https://www.linkedin.com/in/ambermurphy/" target="_blank">
            <font-awesome-icon
              :icon="['fab', 'linkedin']"
              size="2x"
              alt="linkedIn"
              class="social-icon"
            />
          </a>
        </li>
        <li>
          <a href="https://twitter.com/ajm_kohaku" target="_blank">
            <font-awesome-icon
              :icon="['fab', 'twitter-square']"
              size="2x"
              alt="twitter"
              class="social-icon"
            />
          </a>
        </li>

        <li>
          <a href="https://github.com/ajm-kohaku" target="_blank">
            <font-awesome-icon
              :icon="['fab', 'github-square']"
              size="2x"
              alt="github"
              class="social-icon"
            />
          </a>
        </li>

        <li>
          <a href="https://blog.kohaku.me/" target="_blank">
            <font-awesome-icon
              :icon="['fab', 'blogger']"
              size="2x"
              alt="blogger"
              class="social-icon"
            />
          </a>
        </li>
      </ul>
      <div class="copywright">
        2021
        <sup>&copy;</sup> by Amber Murphy. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageBottom"
};
</script>

<style scoped>
ul {
  display: flex;
  justify-content: flex-end;
  list-style-type: none;
  padding: 1em 1em 0 0;
}
ul a {
  display: block;
  padding: 0.2em 0.2em;
}

.copywright {
  text-align: center;
  color: hsl(224, 52%, 94%);
  padding-bottom: 1em;
}

.social-icon,
.social-icon:visited {
  color: hsl(196, 50%, 53%);
  text-decoration: none;
}

.social-icon:hover,
.social-icon:focus {
  color: hsl(224, 52%, 94%);
  text-decoration: none;
}
</style>
